import { combineReducers } from 'redux';

import view from './view';
import merge from './merge';
import visitTrackView from './visit-track-view';

export default combineReducers({
  view,
  merge,
  visitTrackView
});
